import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const getUnleashClientRouter = (c: ReturnType<typeof initContract>) =>
  c.router(
    {
      getVariant: {
        summary: 'Gets user AB test variants',
        method: 'GET',
        path: '/variants',
        query: z.object({ flagName: z.string() }),
        responses: {
          200: z
            .object({
              payload: z.any().nullable(),
              variantName: z.string(),
              isEnabled: z.boolean(),
              isReady: z.boolean(),
            })
            .nullable(),
        },
      },
      setVariant: {
        summary: 'Appends an AB test variant to the user',
        method: 'POST',
        path: '/append-variant',
        body: z.object({
          flagName: z.string(),
          variantName: z.string(),
          enabled: z.boolean(),
          payload: z.any(),
          version: z.string().optional(),
        }),
        responses: {
          201: z.object({ success: z.boolean() }),
        },
      },
      getAbTestDbCachingStatus: {
        summary: 'Returns whether AB test DB caching is currently enabled',
        method: 'GET',
        path: '/caching-status',
        responses: {
          200: z.object({ isDbCachingEnabled: z.boolean() }),
        },
      },
    },
    {
      pathPrefix: '/unleash-client',
    },
  );
